// extracted by mini-css-extract-plugin
module.exports = {"EmptyContainer":"Profile_EmptyContainer__AInE7","EmptyBoxIcon":"Profile_EmptyBoxIcon__1Mggu","EmptyText":"Profile_EmptyText__1t6bg","LoadingIcon":"Profile_LoadingIcon__rE5n_"};